import React, { Fragment } from 'react';
import Imgix, { Picture, Source } from 'react-imgix';

type ImgixResponsivePicture = {
  className?: string;
  src: string;
  breakpointWidthMap: { [breakpoint: number]: number };
  aspectRatio?: number; // (w / h)
  htmlAttributes?:
    | React.ImgHTMLAttributes<HTMLImageElement>
    | React.SourceHTMLAttributes<HTMLSourceElement>
    | Record<string, string>;
};

const ImgixResponsivePicture: React.FC<ImgixResponsivePicture> = ({
  className,
  src,
  breakpointWidthMap,
  aspectRatio,
  htmlAttributes = {},
}) => {
  const breakpointPixels = Object.keys(breakpointWidthMap)
    .map(Number)
    .sort((a, b) => a - b);

  const sources = breakpointPixels
    .map(breakpointPx => {
      const width = breakpointWidthMap[breakpointPx];
      return (
        <Source
          key={`${breakpointPx}`}
          htmlAttributes={{
            media: `(min-width: ${breakpointPx}px)`,
          }}
          width={width}
          height={aspectRatio ? Math.floor(width / aspectRatio) : undefined}
          imgixParams={{ ...(aspectRatio ? { fit: 'fill' } : {}) }}
          src={src}
        />
      );
    })
    .reverse();
  return (
    <Picture>
      {sources.length ? <Fragment>{sources}</Fragment> : <Fragment />}
      <Imgix src={src} htmlAttributes={htmlAttributes} className={className} />
    </Picture>
  );
};

export default ImgixResponsivePicture;
